import {
    ATTEMPT_RESET_PASSWORD,
    UPDATE_SIGN_IN_EMAIL,
} from 'shared_redux/actions';

export const resetPassword = (email) => ({ type: ATTEMPT_RESET_PASSWORD, email });

export const updateEmail = (email) => ({ type: UPDATE_SIGN_IN_EMAIL, email });
